import { Component, Input } from '@angular/core'

/**
 * Chip de la letra con residuo condonado por el editor de saldos (`WRITE_OFF_RESIDUAL`).
 *
 * Lo condonado NO es dinero cobrado: el pendiente ya lo descuenta, así que se enseña aparte para que
 * «aplicado + condonado = renta» se pueda leer en la fila sin abrir el detalle. Es su propio componente
 * para que su plantilla se pruebe sola; el cableado con la letra se prueba en la fila, montando `p-table`
 * con `TableModule` (sin él la fila no se pinta en una prueba unitaria).
 */
@Component({
  selector: 'app-written-off-chip',
  templateUrl: './written-off-chip.component.html',
  styleUrls: ['./written-off-chip.component.scss'],
})
export class WrittenOffChipComponent {
  @Input() amount: number | null | undefined = 0

  /** 0 cuando no hay que pintar: la API anterior no manda el campo y un negativo es un dato roto. */
  get condonado(): number {
    const n = Number(this.amount)
    return Number.isFinite(n) && n > 0 ? n : 0
  }
}
